/************************** Filtering **************************/

// change active class
document.querySelectorAll(".bundleCollectionsFilterGridItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // remove active from all
        document.querySelector(".bundleCollectionsFilterGridItem.active").classList.remove("active");

        // add active to this
        this.classList.add("active");

        // get current filter
        let currentFilter = this.dataset.value;

        // update active classes
        if (currentFilter === "all") {
            document.querySelectorAll(".bundleCollection").forEach(element => element.classList.add("active"));
        } else {
            document.querySelectorAll(".bundleCollection").forEach(function (element) {
                if (currentFilter === element.dataset.value) {
                    element.classList.add("active");
                } else {
                    element.classList.remove("active");
                }
            });
        }

        // update url parameter
        urlParams.set("filter", currentFilter);
        history.replaceState(null, null, `?${urlParams.toString()}`);
    });
});

// check for url param
if (urlParams.get("filter")) {
    // find button with filter value
    let filterButton = document.querySelector(`.bundleCollectionsFilterGridItem[data-value="${urlParams.get("filter")}"]`);

    // check if filter button exists, show all
    if (filterButton) {
        filterButton.click();
    } else {
        document.querySelector(`.bundleCollectionsFilterGridItem`).click();
    }
}


/**************************** Modal ************************/

// open
document.querySelectorAll(".bundleProductOpen").forEach(function (element) {
    element.addEventListener("click", async function () {
        // save modal element
        const modal = document.querySelector(`.bundleModal[data-product-id="${this.dataset.productId}"]`);

        // check if activeVariant is a 3 pac
        if (element.dataset.openThreePack === "true") {
            const threePackElement = modal.querySelector(`.bundleModalOptionInput[name="Pack"][value="3-Pack"]`);
            if (threePackElement) {
                threePackElement.checked = true;
            }
        } else {
            const onePackElement = modal.querySelector(`.bundleModalOptionInput[name="Pack"][value="Single"]`);
            if (onePackElement) {
                onePackElement.checked = true;
            }
        }

        // open modal
        modal.showModal();
    });
});

// loop over all modals
document.querySelectorAll(".bundleModal").forEach(function (modal) {
    // trigger close on exit button click
    modal.querySelector(".bundleModalClose").addEventListener("click", function () {
        this.closest(".bundleModal").close();
    });

    // trigger close on backdrop click
    modal.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });

    /************
     Product Swiper
     ************/

    // setup product swiper
    new Swiper(modal.querySelector(".bundleModalSwiper"), {
        pagination: {
            el: modal.querySelector(".bundleModalSwiperPagination"),
            clickable: true,
        },
        navigation: {
            prevEl: modal.querySelector(".bundleModalSwiperPrev"),
            nextEl: modal.querySelector(".bundleModalSwiperNext"),
        }
    });

    // save product data and activeVariant
    const product = JSON.parse(modal.dataset.product);
    let activeVariant = product.variants[0];

    /**************
     Product Options
     ***************/

    // subscription toggle
    modal.querySelectorAll(".productModalSubscriptionInput").forEach(function (element) {
        element.addEventListener("change", updateProduct);
    });

    // option toggle
    modal.querySelectorAll(".bundleModalOptionInput").forEach(function (element) {
        element.addEventListener("change", function () {
            // manual override for the duradry-am variety pack, preselect the 3-pack
            if (product.handle === "duradry-am" && this.name === "Fragrance" && this.value === "Variety Pack") {
                modal.querySelector(`.bundleModalOptionInput[name="Pack"][value="3-Pack"]`).checked = true;
            }

            updateProduct();
        });
    });

    // update active variant
    function updateProduct() {
        // find active options
        let selectedOptions = [];
        modal.querySelectorAll(".bundleModalOptionInput:checked").forEach(function (element) {
            selectedOptions.push(element.value);
        });

        // if selectedOptions is empty, set the default variant
        if (selectedOptions.length === 0) {
            activeVariant = product.variants[0];
        } else {
            // find the correct variant based on the active options
            activeVariant = null;
            for (let i = 0; i < product.variants.length; i++) {
                if (JSON.stringify(product.variants[i].options) == JSON.stringify(selectedOptions)) {
                    activeVariant = product.variants[i];
                    break;
                }
            }
        }

        // check for null variant
        if (activeVariant === null) {
            modal.querySelector("#bundleModalATC").disabled = true;
            modal.querySelector("#bundleModalATC").innerHTML = `Not Available`;
            return;
        }

        // update images if the variant has them
        if (activeVariant.featured_image) {
            modal.querySelector(".bundleModalSwiperImageVariant").src = `${activeVariant.featured_image.src}&width=1000`;
        }

        // check for subscription
        const isSubscription = !!modal.querySelector("#productSubscribeV2:checked");

        // update subscription info
        if (isSubscription) {
            // show subscription info (benefits)
            modal.querySelector("#bundleModalSubscriptionInfo").classList.add("active")

            // get message for left bullet (normalyl comes from the pack description)
            let subscriptionInfo = modal.querySelector(".bundleModalOptionsPacksItem:has(:checked) .bundleModalOptionsPacksItemInfoDescription.active")?.textContent || "Save 15% on every order";

            // override for 3-step-system
            if (product.handle === "3-step-system-90d") {
                subscriptionInfo = "Auto-delivers every 3 months";
            }

            // update subscription info
            modal.querySelector("#bundleModalSubscriptionInfoCadence").textContent = subscriptionInfo;
        } else {
            modal.querySelector("#bundleModalSubscriptionInfo")?.classList.remove("active")
        }

        // update descriptions
        modal.querySelectorAll(".bundleModalOptionsPacksItemInfoDescription").forEach(element => element.classList.remove("active"));
        modal.querySelectorAll(`.bundleModalOptionsPacksItemInfoDescription.${isSubscription ? "subscription" : "onetime"}`).forEach(element => element.classList.add("active"));

        // calculate real price, compare price and savings
        let realPrice, comparePrice, savings;
        if (isSubscription) {
            realPrice = activeVariant.price * 0.85;
        } else {
            realPrice = activeVariant.price;
        }

        // calculate compare at price savings
        comparePrice = activeVariant.compare_at_price || activeVariant.price;
        savings = Math.round((1 - (realPrice / comparePrice)) * 100);

        // update product price
        modal.querySelector("#bundleModalPrice span").textContent = price(realPrice);
        if (realPrice < comparePrice) {
            modal.querySelector("#bundleModalPrice s").textContent = price(comparePrice);
            modal.querySelector("#bundleModalPrice badge").textContent = `${savings}% OFF`;
        } else {
            modal.querySelector("#bundleModalPrice s").textContent = "";
            modal.querySelector("#bundleModalPrice badge").textContent = "";
        }

        // check if the variant is in stock
        if (activeVariant.available === true) {
            modal.querySelector("#bundleModalATC").disabled = false;
            modal.querySelector("#bundleModalATC").innerHTML = `Add To Cart - <span>${price(realPrice)}</span>`;
        } else {
            modal.querySelector("#bundleModalATC").disabled = true;
            modal.querySelector("#bundleModalATC").innerHTML = `Sold Out - <span>${price(realPrice)}</span>`;
        }

        // update pack pricing
        modal.querySelectorAll(".bundleModalOptionsPacksItem").forEach(function (element) {
            // save the prices
            const unitPrice = parseFloat(element.dataset.unitPrice);
            const packPrice = parseFloat(element.dataset.packPrice);

            // save elements
            const unitPriceElement = element.querySelector(".bundleModalOptionsPacksItemPriceUnit");
            const packPriceElement = element.querySelector(".bundleModalOptionsPacksItemPriceTotal");

            // calculate purchase price
            if (isSubscription) {
                if (unitPriceElement) unitPriceElement.textContent = `$${Math.ceil(unitPrice * 0.85)} ea.`;
                packPriceElement.textContent = price(packPrice * 0.85);
            } else {
                if (unitPriceElement) unitPriceElement.textContent = `$${Math.ceil(unitPrice)} ea.`;
                packPriceElement.textContent = price(packPrice);
            }
        });

        // update fragrance title and description (am-stick)
        const activeFragranceInput = modal.querySelector(`#bundleModalOptionsFragrances .bundleModalOptionInput:checked`);
        if (activeFragranceInput) {
            modal.querySelector("#bundleModalOptionsFragrancesTitle").innerHTML = `Fragrance: <b>${activeFragranceInput.value}</b>`;
            modal.querySelector("#bundleModalOptionsFragrancesDesc").textContent = activeFragranceInput.dataset.description;
        }

        // update size title and description (duradry-wash)
        const activeSizeInput = modal.querySelector(`#bundleModalOptionsSizes .bundleModalOptionInput:checked`);
        if (activeSizeInput) {
            modal.querySelector("#bundleModalOptionsSizesTitle").innerHTML = `Size: <b>${activeSizeInput.value}</b>`;
        }

        // manual override of duradry-wash since the size selector has different pricing
        if (product.handle === "duradry-wash") {
            // if 2.5 FL
            if (modal.querySelector(`.bundleModalOptionInput[name="Size"][value="2.5 FL. OZ."]:checked`)) {
                let unitPrices = [8.33, 7, 10];
                let realPrices = [4200, 2500, 1000];

                if (isSubscription) {
                    modal.querySelectorAll(".bundleModalOptionsPacksItemPriceUnit").forEach((element, index) => element.textContent = `$${Math.ceil(unitPrices[index] * 0.85)} ea.`);
                    modal.querySelectorAll(".bundleModalOptionsPacksItemPriceTotal").forEach((element, index) => element.textContent = price(realPrices[index] * 0.85));
                } else {
                    modal.querySelectorAll(".bundleModalOptionsPacksItemPriceUnit").forEach((element, index) => element.textContent = `$${Math.ceil(unitPrices[index])} ea.`);
                    modal.querySelectorAll(".bundleModalOptionsPacksItemPriceTotal").forEach((element, index) => element.textContent = price(realPrices[index]));
                }
            }
        }

    }

    // update product selection
    updateProduct();

    /**************
     Product ATC
     ***************/

    modal.querySelector("#bundleModalATC").addEventListener("click", async function (e) {
        e.preventDefault();

        // add loading animation
        this.classList.add("loading");

        // setup form data
        let formData = {
            items: []
        };

        // add main product
        formData.items.push({
            quantity: 1,
            id: activeVariant.id,
        });

        // check for subscription
        const isSubscription = !!modal.querySelector("#productSubscribeV2:checked");

        // add subscription if needed
        if (isSubscription) {
            formData.items[0].selling_plan = cadenceToPlan[variantToCadence[activeVariant.id]];
        }

        // add product
        await addProduct(formData);

        // refresh cart
        cart = await fetch("/cart.js")
            .then(data => data.json());

        // stop loading
        this.classList.remove("loading");

        // close modal
        modal.close();

        // open cart
        await openCart(true);
    });

    // register dialog
    dialogPolyfill.registerDialog(modal);
});